module.exports = __webpack_public_path__ + "static/media/piper-fail-3.4647f982.svg";